// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"f47e2bbf","98":"ac08a10e","139":"55ab6c10","150":"35f83cf2","307":"aa6317b3","495":"6509dba0","876":"5baaca5b"}[chunkId] + ".chunk.js";
};